import React, { useState, useEffect } from 'react';

function IconsField({ field, updateGlobalFilter, initialSelectedOptions = [], col }) {
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions);

  useEffect(() => {
    const selectedTitles = field.fields_icons
      .filter((_, idx) => selectedOptions.includes(idx))
      .map((icon) => icon.title);
    updateGlobalFilter(field.field, selectedTitles);
  }, [selectedOptions, field, updateGlobalFilter]);

  const onIconChange = (optionId) => {
    setSelectedOptions((prevSelectedOptions) => {
      return prevSelectedOptions.includes(optionId)
        ? prevSelectedOptions.filter((id) => id !== optionId)
        : [...prevSelectedOptions, optionId];
    });
  };

  return (
    <div className="mb-4">
      <h4 className="font-bold mb-2 text-lg">{field.title}</h4>
      <div className="flex gap-6 image-checkboxes">
        {field.fields_icons.map((f, iconIndex) => (
          <div key={iconIndex} className="text-center w-16 xl:w-20">
            <input
              type="checkbox"
              id={`checkbox-${field.uniqueId}-${iconIndex}`}
              name={f.title}
              className="hidden"
              checked={selectedOptions.includes(iconIndex)}
              onChange={() => onIconChange(iconIndex)}
            />
            <label htmlFor={`checkbox-${field.uniqueId}-${iconIndex}`} className="cursor-pointer">
              <img src={f.icon} alt={f.title} />
              <span className="block text-xs font-medium">{f.title}</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IconsField;